export default __webpack_public_path__ + "static/media/Category_background.1218d158.png";